import { createStore } from '@'

export const $users = createStore('card:users')
